import { BaseField } from './BaseField';

const imgPriceIcon = "/assets/price-icon.svg";

export class PriceField extends BaseField {
  constructor() {
    super({
      key: 'price',
      icon: imgPriceIcon,
      defaultLabel: 'Cena'
    });
  }

  _label(property, params = {}) {
    if (params.label) return params.label;
    return property.propertyType === 'lokal uslugowy' ? 'Cena (netto)' : this.defaultLabel;
  }

  _value(property) {
    const value = property.pricing.totalPrice.value;
    if (!Number.isFinite(value)) return 'Nie podano';
    return `${value.toLocaleString('pl-PL')} zł`
  }

  _result(property, params = {}) {
    const result = {
      label: this._label(property, params),
      value: this._value(property)
    };
    if (property.priceBadge?.isVisible) {
      const areaTotal = property.specifications?.area?.total;
      result.promo = {
        originalPrice: `${property.priceBadge.originalPrice.toLocaleString('pl-PL')} zł`,
        originalPricePerSqm: areaTotal > 0
          ? `${Math.round(property.priceBadge.originalPrice / areaTotal).toLocaleString('pl-PL')} zł/m²`
          : null
      };
    }
    return result;
  }

  renderForList(property, params = {}) {
    return this._result(property, params);
  }

  renderForCard(property, params = {}) {
    return this._result(property, params);
  }
}
